
import React from 'react';
import { cn } from '@/lib/utils';

interface GradientButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  variant?: 'primary' | 'secondary';
}

const GradientButton = ({
  children,
  className,
  variant = 'primary',
  ...props
}: GradientButtonProps) => {
  return (
    <button
      className={cn(
        "relative overflow-hidden font-montserrat font-medium rounded-full transition-all duration-300",
        "inline-flex items-center justify-center px-6 py-3",
        "text-white shadow-md",
        "hover:shadow-lg hover:scale-105 active:scale-95",
        variant === 'primary' 
          ? "bg-gradient-to-r from-yellow-400 to-yellow-600" 
          : "bg-gray-700",
        className
      )}
      {...props}
    >
      <span className="relative z-10">{children}</span>
      <span className="absolute inset-0 bg-gradient-to-r from-yellow-500 to-yellow-700 opacity-0 transition-opacity duration-300 hover:opacity-100" />
    </button>
  );
};

export default GradientButton;
